export enum ResolverContractType {
  PublicResolver = 'public',
  RoleDefinitionResolver_v1 = 'roledefv1',
  RoleDefinitionResolver_v2 = 'roledefv2',
}
